import { Pattern1 } from "@/(front-desk)/utils/patterns"
import { useState } from "react"
import banner2024 from "@/(front-desk)/assets/images/2024/banner.png"
import classNames from "classnames"

const yearList = {
    2024: 
        <>
        <img className="mb-[2.25rem]" src={banner2024.src} />
        <div className="text-[2.5rem] text-white font-bold mb-[2.25rem]">
            2024 放視大賞 <br/>
            SPARKLES
        </div>
        <div className="text-white font-light mb-[2rem]">
            2024 放視大賞，以「光芒」為呼召的主概念。提及設計比賽，大多人會將它和畢業、得獎、時事、議題等詞彙聯想，但今年我們的主視覺概念非常單純，僅強調來自「作品本身的光芒」。正因為這很有可能是學生們僅有一次、甚至可能是踏入職場前最後一次的高光時刻，我們將此概念化作主視覺意象，以銳利的星芒符號，衍伸出主視覺標準字，與它背後的意義——
        </div>
        <div className="text-[1.75rem] text-[#F2A3E7] font-semibold mb-[2rem]">
            不要圓滑，要尖銳。<br/>
            不要隱諱，要發光。<br/>
            不只是好設計，<br/>
            也要是你自己喜歡的設計。
        </div>
        <div className="text-white font-light mb-[3rem]">
            本年度標準字，也不僅限於一種字體。經由極大量且特質迥異的字體、透過 AI 生成的無數標籤，將「各式各樣」「百花齊放」等複合、演算、自由的特性框入主視覺之中，連所有報名參展的學校、學校的英文縮寫、與中文全名，都萬川入海加入拼湊成「Vision Get Wild」的數位紋理。這個主視覺透露出一種態度：我們期待千奇百怪的概念與風格、我們鼓勵學生研究自己真正有興趣的專題、我們寄望大家打造出自己嚮往的世界，與最重要的，我們希望所有人端出他們「自己真正喜歡」的作品。
        </div>
        <div className="text-[0.875rem] text-black-500 font-light">
            The 2024 Vision Get Wild, centered around the overarching concept of "Sparkles." However, this year, our main visual concept is exceptionally simple, solely emphasizing the "radiance sparkles from the works themselves." Due to the likelihood that this might be students' only, or even potentially their last, shining moment before entering the workforce, we have transformed this concept into the primary visual image. <br/>
            Utilizing sharp starburst symbols, we derive the main logotype and convey the underlying message: Be sharp, don’t be smooth. Shine, don't hide. It's not just about good design; it's about designs you personally love.<br/>
            This primary visual communicates a certain attitude: We anticipate diverse concepts and styles, encourage students to delve into topics they are genuinely interested in, hope everyone creates the world they aspire to, and most importantly, we want everyone to present works they truly love.
        </div>
        </>
}

export default function History() {
    
    const years = Object.keys(yearList)
    const [ active, setActive ] = useState(years[0])

    return (
        <div className="history flex flex-col gap-[3rem]">
            {/* <div className="flex flex-col md:flex-row items-start md:items-center gap-[2.25rem]"> */}
            <div className="flex flex-col md:flex-row items-start gap-[2.25rem]">
                <div className="text-[1.875rem] text-white font-semibold whitespace-nowrap">歷年放視</div>
                {/* <div className="w-full md:w-[calc(100%-10rem)] overflow-x-scroll overflow-y-hidden"> */}
                    {/* <div className="flex gap-4"> */}
                    <div className="flex flex-wrap sm:!gap-4 gap-3">
                        { years.map((year) => (
                            <button
                                key={`year-${year}`}
                                className={classNames('btn-round', {
                                    'btn-main': year === active,
                                    'btn-main-700': year !== active
                                })}
                                onClick={() => setActive(year)}
                            >{year}</button>
                        ))}
                    </div>
                {/* </div> */}
            </div>
            <div className="flex gap-[1.87rem]">
                <div className="flex-center flex-col gap-3 px-[1.2rem] !hidden md:!flex">
                    <Pattern1 className="w-[1.5rem] fill-black-600" />
                    <div className="text-[0.75rem] text-black-600 font-light">{active}</div>
                    <div className="h-full border-s border-[0.5px] border-black-600 w-fit"></div>
                </div>
                <div className="">
                    {yearList[active]}
                </div>
            </div>
        </div>
    )
}